import { withRouter } from 'react-router-dom'
import React from 'react'
import { connect } from 'react-redux'
import { requestLogout, switchWorkcenter } from '../actions/AuthActions'

const mapStateToProps = state => ({
  authenticated: state.auth.session.token !== false,
  name: state.auth.session.username,
  workcenter_name: state.auth.session.workcenter_name,
  workcenters: state.auth.workcenters
})

const mapDispatchToProps = dispatch => ({
  requestLogoutAction: () => dispatch(requestLogout()),
  switchWorkcenterAction: () => dispatch(switchWorkcenter())
})

class HeaderComponent extends React.Component {
  logout = () => {
    if (window.confirm('Czy na pewno chcesz się wylogować?')) {
      this.props.requestLogoutAction()
    }
  }

  render() {
    const { authenticated, name, workcenter_name, workcenters, switchWorkcenterAction } = this.props

    return (
      <header>
        <div className="logo">
          <span className="logo__mark">IC</span>
          <span className="logo__text">
            {workcenter_name ? `Stanowisko ${workcenter_name}` : 'Panel produkcji'}
          </span>
        </div>
        {authenticated ? (
          <div className="nav">
            <div className="auth_info">
              <span className="auth_info_name">{name}</span>
              <span className="auth_info_zone">{workcenter_name}</span>
            </div>
            {workcenters && workcenters.length > 1 && (
              <button type="button" className="switch-workcenter" onClick={switchWorkcenterAction}>
                Zmień stanowisko
              </button>
            )}
            <button type="button" className="logout" onClick={this.logout}>
              Wyloguj
            </button>
          </div>
        ) : ''}
      </header>
    )
  }
}
const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderComponent)

export default withRouter(Header)
